import React from "react";
import { ChevronRightIcon } from "lucide-react";
import { GlitterSparkles } from "./GlitterSparkles";
export type Subcategory = {
  label: string;
  path: string;
};
type SubcategoryMenuProps = {
  title: string;
  description: string;
  subcategories: Subcategory[];
  onOpen: (path: string) => void;
  onBack: () => void;
};
export function SubcategoryMenu({
  title,
  description,
  subcategories,
  onOpen,
  onBack
}: SubcategoryMenuProps) {
  return <main className="relative min-h-[100dvh] w-full bg-[#10070f] px-4 py-10 text-white sm:px-8 sm:py-14" data-id="element-380" data-mp="19xgm149etn49">
      <div className="pointer-events-none fixed inset-0" aria-hidden="true" data-id="element-381" data-mp="1ewa0aywiti5h">
        <GlitterSparkles count={450} data-id="element-382" data-mp="1iyyab9wz0v41" />
      </div>
      <div className="relative mx-auto max-w-5xl" data-id="element-383" data-mp="1nrhn44nu3m7s">
        <button type="button" onClick={onBack} className="mb-8 text-sm font-medium text-[#35dceb] underline decoration-transparent underline-offset-4 transition-colors duration-150 ease-out hover:decoration-current focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#35dceb]" data-id="element-384" data-mp="1ns99covjk7le">
          Back to home
        </button>
        <header className="border-b border-[#ff3aa2]/60 pb-6" data-id="element-385" data-mp="3a4ya8mqjrvze">
          <h1 className="text-3xl font-semibold tracking-tight text-[#ff5bad] sm:text-4xl" data-id="element-386" data-mp="35b3icw0sgap8">{title}</h1>
          <p className="mt-2 text-sm text-white/70" data-id="element-387" data-mp="30c0kbvj874qr">{description}</p>
        </header>
        <nav className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-2" aria-label={`${title} types`} data-id="element-388" data-mp="2ve7h9bd7yqup">
          {subcategories.map(subcategory => <button key={subcategory.path} type="button" onClick={() => onOpen(subcategory.path)} className="flex items-center justify-between gap-3 border border-[#ff3aa2]/60 bg-[#220d20] px-5 py-5 text-left text-base font-medium text-white transition-colors duration-150 ease-out hover:bg-[#3a1232] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#35dceb]" data-id="element-389" data-mp="2regl0s4xbiis">
              {subcategory.label}
              <ChevronRightIcon size={18} className="shrink-0 text-[#35dceb]" aria-hidden="true" data-id="element-390" data-mp="2etrngxyy0x74" />
            </button>)}
        </nav>
      </div>
    </main>;
}